import { gql } from '@apollo/client';

export const GENERATE_SALES_REPORT = gql`
    query GenerateSalesReport($salesReportParams: SalesReportParams!) {
        generateSalesReport(salesReportParams: $salesReportParams) {
            buffer
            fileName
        }
    }
`;
